import { NgClass } from '@angular/common'
import { Component, Input, ViewChild } from '@angular/core'
import { DropdownComponent } from '@app/v2/shared/components/dropdown/dropdown.component'
import { ComponentWithDataSetter } from '@app/v2/shared/components/dropdown/types/dropdown-option.type'
import { Registration } from '@database/models/registration.model'
import { FlagDropdownPanelComponent } from './flag-dropdown-panel.component'

@Component({
  selector: 'app-flag-dropdown',
  templateUrl: './flag-dropdown.component.html',
  standalone: true,
  imports: [NgClass, DropdownComponent]
})
export class FlagDropdownComponent {
  @Input({ required: true }) registrant: Registration
  @ViewChild('dropdown') dropdown?: DropdownComponent

  /**
   * @description Current flag color for the trigger icon.
   * @returns Flag color or null when the registration is unflagged.
   */
  public get flagColor(): 'red' | 'orange' | 'green' | null {
    return this.registrant?.getFlagColor() ?? null
  }

  /**
   * @description Config that mounts the flag panel inside `app-dropdown`.
   * @returns ComponentWithDataSetter for FlagDropdownPanelComponent.
   */
  public get panelConfig(): ComponentWithDataSetter<FlagDropdownPanelComponent> {
    return {
      component: FlagDropdownPanelComponent,
      dataSetter: (instance) => {
        instance.registrant = this.registrant
        instance.closeDropdown = () => this.dropdown?.close()
      }
    }
  }
}
